import * as React from 'react';

import './signature.css';

import { SignaturePreview } from '@/ui-kit/signature/signature-preview/signature-preview';
import { SignatureModal } from '@/ui-kit/signature/signature-modal/signature-modal';
import { Icon } from '@/ui-kit/icon/icon';
import { Button } from '@/ui-kit/button/button';

interface SignatureProps extends React.HTMLAttributes<HTMLDivElement> {
  url?: string;
  onClear: () => void;
  onAdd: (signature: string) => void;
}

const Signature = React.forwardRef<HTMLDivElement, SignatureProps>(
  ({ url, onClear, onAdd }, ref) => {
    const mainButtonLabel = (url !== undefined ? 'Edit' : 'Add') + ' Signature';
    const [isOpen, setIsOpen] = React.useState(false);

    const openModal = () => {
      setIsOpen(true);
    };

    const closeModal = () => {
      setIsOpen(false);
    };

    const handleClear = () => {
      onClear?.();
    };

    return (
      <div ref={ref} className="signature__container">
        {url !== undefined && (
          <SignaturePreview previewUrl={url} onClear={handleClear} />
        )}
        <Button
          type="button"
          kind="default"
          variant="secondary"
          size="hero"
          leadingIcon={<Icon size="medium" type="quill" />}
          onClick={openModal}
        >
          {mainButtonLabel}
        </Button>
        <SignatureModal
          isOpen={isOpen}
          onClose={closeModal}
          onAddSignature={onAdd}
        />
      </div>
    );
  },
);

export { Signature };
